<template>
  <body>
    <div class="cont">
        <div class="logo-placeholder">
          <img :src="'/imgs/aruvaa_logo.png'" alt="logo" class="logo" />
            <h2 class="mt-3 text-gray-700 font-semibold">Comig Soon</h2>
        </div>
        <div class="content">
            <p class="text-md font-medium text-gray-700">Your Next Favorite Experience Is Coming!</p>
        </div>
    </div>

    <footer class="footer">
      <!-- Your footer content goes here -->
      <p> 2019 &copy; Aruvaa, All Rights Reserved</p>
    </footer>
</body>

 </template>
 
 <script>
 import AppLayout from "@/Layouts/AppLayout.vue";
 import NavBar from "@/Layouts/NavBar.vue";
 
 export default {
   props: {
     selectedId: String,
     selectedType: String,
   },
   components: {
     AppLayout,
     NavBar,
   },
   data() {
     return {
           
     };
   },
 
    methods: {
 
   },
   mounted() {
  
 
   },
 };
 </script>
 
 <style>
 
 body {
            font-family: "SF Pro Display","SF Pro Icons","Helvetica Neue","Helvetica","Arial",sans-serif;
            max-width: 672px;
            width: 100%;
            height: 300px;
            margin: 10px auto;
            font-size: 16px;
            line-height: 1.5;
            font-weight: 300;
            color: black;
            background:url('/imgs/Aruvaa_coming.jpg') no-repeat center center fixed;      
        }

       .remove-top-margin {
            margin-top: 0;
        }
       
        .cont{
          position: absolute;
            top: 40%;
            left: 50%;
            transform: translate(-50%, -50%);
            text-align: center;
        }
        .logo-placeholder {
            /* padding: 5px; */
            text-align: center;
        }

        /* Add Footer Styles */
.footer {
  position: fixed;
  bottom: 0;
  left: 0;
  width: 100%;
  /* background: #333;  */
  background:linear-gradient(20deg, rgba(0, 0, 0, 0.863), rgba(0, 0, 0, 0.64));
  color: white;
  text-align: center;
  padding: 10px;
}
     
 </style>
